import { Route, Routes, Navigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { isMobile } from 'react-device-detect';
import { useLocale } from '../../lib/context/locale-context';

import Intro from './Intro';

export default function IntroRoute() {
  const [cookies] = useCookies(['cookie_token']);
  const { localePrefix } = useLocale();
  if (isMobile || cookies.cookie_token === 'true') {
    return <Navigate replace to={`${localePrefix}/home`} />;
  }

  return (
    <Routes>
      <Route path="/" element={<Intro />} />
    </Routes>
  );
}
